import React from 'react';
import { Icon } from './Icon.jsx';

export function IconButton({
  icon, label, size = 'md', variant = 'plain', active = false,
  disabled = false, className = '', ...rest
}) {
  const cls = [
    'sp-iconbtn', 'sp-iconbtn--' + size,
    variant !== 'plain' && 'sp-iconbtn--' + variant,
    active && 'sp-iconbtn--active', className
  ].filter(Boolean).join(' ');
  return (
    <button className={cls} aria-label={label} title={label} disabled={disabled} {...rest}>
      <Icon name={icon} size={size === 'lg' ? 18 : size === 'sm' ? 14 : 16} />
    </button>
  );
}
